import { render, staticRenderFns } from "./DesktopNavigation.vue?vue&type=template&id=0f4736fe&scoped=true"
import script from "./DesktopNavigation.vue?vue&type=script&lang=js"
export * from "./DesktopNavigation.vue?vue&type=script&lang=js"
import style0 from "./DesktopNavigation.vue?vue&type=style&index=0&id=0f4736fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4736fe",
  null
  
)

export default component.exports